import Vue from 'vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

import { extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

extend('required', {
    ...required,
    message: '{_field_} ist ein Pflichtfeld',
});

extend('email', {
    ...email,
    message: 'Dies ist keine gültige E-Mail Adresse',
});
